import { CheckCircleOutline, HighlightOffOutlined } from "@mui/icons-material";
import { Box, IconButton, InputAdornment } from "@mui/material";

export type TextFieldActivityAdornmentProps = {
    value: boolean;
    onChange: (value: boolean) => void;
};

export function TextFieldActivityAdornment({ value, onChange }: TextFieldActivityAdornmentProps) {
    const isActive = value;

    const handleToggleActive = () => {
        onChange(!isActive);
    };

    return (
        <InputAdornment position="end">
            <IconButton onClick={handleToggleActive}>
                <Box display="flex" flexDirection="column" alignItems="center" width="50px">
                    {isActive ? (
                        <CheckCircleOutline color="success" />
                    ) : (
                        <HighlightOffOutlined color="error" />
                    )}
                </Box>
            </IconButton>
        </InputAdornment>
    );
}
